module.exports = __webpack_public_path__ + "static/media/foursquare.d0c82e44.png";